
<div class="app-body-pos" >
  <div class="main">
    <router-outlet></router-outlet>
  </div>

</div>

